import { ComponentPropsWithRef } from 'react';

export const StarsSvg = (props: ComponentPropsWithRef<'svg'>) => (
  <svg
    width="1138"
    height="399"
    viewBox="0 0 1138 399"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M443.999 115.436L601.027 52.0825"
      stroke="url(#paint0_linear_158_1013)"
      strokeOpacity="0.3"
      strokeLinecap="round"
    />
    <path
      d="M80.0002 182.062L240.072 150.001"
      stroke="url(#paint1_linear_158_1013)"
      strokeOpacity="0.3"
      strokeLinecap="round"
    />
    <path
      d="M297.223 164.392L215.777 132.213"
      stroke="url(#paint2_linear_158_1013)"
      strokeOpacity="0.3"
      strokeLinecap="round"
    />
    <circle cx="2" cy="80" r="2" fill="#DCCEF5" fillOpacity="0.4" />
    <circle cx="18" cy="395" r="4" fill="#DCCEF5" />
    <circle cx="843" cy="196" r="2" fill="#DCCEF5" />
    <circle cx="1134" cy="224" r="4" fill="#EA9F54" />
    <defs>
      <linearGradient
        id="paint0_linear_158_1013"
        x1="443.968"
        y1="125.087"
        x2="519.906"
        y2="179.715"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C0C7FF" stopOpacity="0.2" />
        <stop offset="0.539955" stopColor="#D6C6FF" />
        <stop offset="0.923056" stopColor="#C0C7FF" stopOpacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_158_1013"
        x1="77.1158"
        y1="192.692"
        x2="142.032"
        y2="258.607"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C0C7FF" stopOpacity="0.2" />
        <stop offset="0.539955" stopColor="#D6C6FF" />
        <stop offset="0.923056" stopColor="#C0C7FF" stopOpacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_158_1013"
        x1="297.238"
        y1="169.295"
        x2="258.41"
        y2="197.813"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C0C7FF" stopOpacity="0.2" />
        <stop offset="0.539955" stopColor="#D6C6FF" />
        <stop offset="0.923056" stopColor="#C0C7FF" stopOpacity="0.2" />
      </linearGradient>
    </defs>
  </svg>
);
